var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50039 10.2337C2.83176 10.2337 3.10039 10.5024 3.10039 10.8337V12.1671C3.10039 12.572 3.42876 12.9004 3.83372 12.9004H12.1671C12.572 12.9004 12.9004 12.572 12.9004 12.1671V10.8337C12.9004 10.5024 13.169 10.2337 13.5004 10.2337C13.8318 10.2337 14.1004 10.5024 14.1004 10.8337V12.1671C14.1004 13.2348 13.2348 14.1004 12.1671 14.1004H3.83372C2.76602 14.1004 1.90039 13.2348 1.90039 12.1671V10.8337C1.90039 10.5024 2.16902 10.2337 2.50039 10.2337Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00039 1.90039C8.33176 1.90039 8.60039 2.16902 8.60039 2.50039V10.1671C8.60039 10.4984 8.33176 10.7671 8.00039 10.7671C7.66902 10.7671 7.40039 10.4984 7.40039 10.1671V2.50039C7.40039 2.16902 7.66902 1.90039 8.00039 1.90039Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57613 8.40946C5.81044 8.17515 6.19034 8.17515 6.42465 8.40946L8.00039 9.9852L9.57613 8.40946C9.81044 8.17515 10.1903 8.17515 10.4247 8.40946C10.659 8.64377 10.659 9.02367 10.4247 9.25799L8.42465 11.258C8.19034 11.4923 7.81044 11.4923 7.57613 11.258L5.57613 9.25799C5.34181 9.02367 5.34181 8.64377 5.57613 8.40946Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/Download-white.99f389f595228a7e2ec2e5fb4e6d179d.svg";
export { ForwardRef as ReactComponent };